<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- Cancellations -->
          <b-card class="border-0">
            <b-row>
              <b-col lg="9" md="9" sm="12">
                <div class="card-text pb-0">
                  <div class="d-flex flex-column justify-content-start">
                    <div class="text-dark mr-3">
                      <span class="mr2 headericon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2 0v24h20v-24h-20zm5 22h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm5 8h-3v-7h3v7zm0-8h-3v-3h3v3zm0-6h-16v-6h16v6zm-1-1h-14v-4h14v4z"/></svg></span>
                      <span class="h4 font-weight-bold text-dark">KreditTjek</span>
                    </div>
                    <p class="py-3 open-sans h6 line-height-golden">
                      Neostructuralist rationalism holds that language is capable of truth, given that the premise of the conceptualist paradigm of reality is invalid. Thus, many discourses concerning the common ground between sexual identity and society may be discovered.
                      <br><br>
                      <b-btn variant="outline-dark" v-b-modal.conditions>
                        <span class="font-weight-bold">Læs betingelserne</span>
                      </b-btn>
                      <b-modal id="conditions" ref="conditions">
                        <div slot="modal-header" class="w-100">
                          <div class="d-flex justify-content-between">
                            <div class="text-dark font-weight-bold line-height-golden headerfont h5">
                              Modal Header
                            </div>
                            <div>
                              <b-btn variant="outline-danger" block @click="hideModal" class="border-0">
                                <span class="el-icon-error"></span>
                              </b-btn>
                            </div>
                          </div>
                        </div>
                        <slot name="modal-content">
                          Modal content
                        </slot>
                        <div slot="modal-footer">
                          <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Close Me</b-btn>
                        </div>
                      </b-modal>
                    </p>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                <b-list-group>
                  <b-list-group-item class="border-0">
                    <p class="w-50 d-inline-block float-left m-0 p-0">Du har købt</p>
                    <p class="w-50 d-inline-block float-right text-right m-0 p-0">
                      <span class="bg-info pt-1 pb-1 pr-2 pl-2 rounded mr-1">{{ kredits }}</span>
                      klip
                    </p>
                  </b-list-group-item>
                  <b-list-group-item class="border-0">
                    <p class="w-50 d-inline-block float-left m-0 p-0">Du har brugt</p>
                    <p class="w-50 d-inline-block float-right text-right m-0 p-0">
                      <span class="bg-success pt-1 pb-1 pr-2 pl-2 rounded mr-1">{{ kredits_create }}</span>
                      klip
                    </p>
                  </b-list-group-item>
                  <b-list-group-item class="border-0 text-center">
                    <b-btn variant="outline-success" type="button" @click="showShop()" class="font-weight-bold">
                      <span class="headericon mr2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2 0v24h20v-24h-20zm5 22h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm5 8h-3v-7h3v7zm0-8h-3v-3h3v3zm0-6h-16v-6h16v6zm-1-1h-14v-4h14v4z"/></svg></span>
                      Køb flere KreditTjek klip
                    </b-btn>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-card>
          <!-- <creditchecklist :kredit_items="kredit_items" :claim_items="claim_items" @claimCheck="claimCheck"></creditchecklist> -->
          <b-card class="p-0 pt-4 border-0 creditcheck-container" bg-variant="white">
            <creditcheckform :creditCheck="creditCheck" @creditSubmit="creditSubmit" :isLoadingSubmit="isLoadingSubmit"></creditcheckform>
          </b-card>
        </b-col>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      <b-modal centered lazy v-model="reviewShowShop" size="lg"  title="Køb flere KreditTjek klip"  ref="reviewModalShop" class="p-2">
        <!-- header -->
        <div class="modal-content border-0 open-sans">
          <div class="py-4"></div>
          <b-form @submit="onSubmitPurchaseInfo" >
            <fieldset>
              <b-form-row>
                <b-container class="bv-example-row">
                  <b-row >
                    <b-col v-for="packageOption in packageOptions" :key="packageOption.id"><div>
                      <b-form-group>
                        <b-card :img-src="packageOption.image" img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                          <p class="card-text">{{ packageOption.total }} kr.</p>
                          <p class="card-text">{{ packageOption.description }}</p>
                          <div slot="header">
                            <input type="radio" :id="packageOption.id" :value="packageOption.id" class="radion_select" v-model="picked"> <label label :for="packageOption.id" class="h4 font-weight-normal">{{ packageOption.productname }}</label> </input>
                          </div>
                        </b-card>
                      </b-form-group>
                    </div></b-col>
                  </b-row>
                </b-container>
              </b-form-row>
            </fieldset>
            <div class="py-4"></div>
            <b-container class="py-4">
              <b-row no-gutters>
                <b-col cols="2" class="mx-auto">
                  <b-btn class="bg-success border-0  " size="lg" type="submit">
                    <span class="d-inline-block"><credit-card-icon/></span>
                    <span class="font-weight-bold text-white d-inline-block mr-2">Købe</span>
                  </b-btn>
                </b-col>
              </b-row>
              <loading :show="show" :label="label" :overlay="overlay"></loading>
              <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
            </b-container>
          </b-form>
          <div class="py-4"></div>
        </div>
        <div slot="modal-footer">
          <b-row class="pt-0 pr-2 pb-4 pl-2">
            <b-col>
              <b-btn type="reset" slot="modal-cancel" variant="outline-info" size="lg" @click="closeShopModal" class="rounded">Luk</b-btn>
            </b-col>
          </b-row>
        </div>
        <!-- modalFooter -->
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import creditcheckform from './CreditCheckForm'
import creditchecklist from './CreditcheckList'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  components: {
    creditcheckform,
    creditchecklist,
    loading,
    Simplert
  },
  created () {
    this.Reload()
  },
  data () {
    return {
      kredits: '',
      kredit_items: '',
      claim_items: '',
      reviewShowShop: false,
      isLoadingSubmit: false,
      packageOptions: [],
      picked: '',
      overlay: true,
      show: false,
      label: 'Loading...',
      kredits_create: '',
      creditCheck: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        streetName: '',
        houseNumber: '',
        houseFloor: '',
        houseSide: '',
        city: '',
        zip: '',
        cprNumber: '',
        consent: ''
      }
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_credit', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.kredit_items = res.items
            this.kredits = res.kredits
            this.claim_items = res.claim
            this.kredits_create = res.kredits_create
            this.packageOptions = res.package
          },
          response => {
            alert('error')
          }
        )
    },
    onSubmitPurchaseInfo (evt) {
      evt.preventDefault()
      if (this.picked === '') {
        let obj = {
          title: 'Fejl',
          message: 'Vælg Pakke',
          type: 'error',
          customCloseBtnText: 'Luk'
        }
        this.$refs.simplert.openSimplert(obj)
        return false
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'addKreditSale', salesPerson: this.salesPerson, package: this.picked, levid: this.haaId }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              alert('Gennemført!')
              this.picked = ''
              this.$refs.reviewModalShop.hide()
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    closeShopModal () {
      this.$refs.reviewModalShop.hide()
    },
    showShop () {
      this.reviewShowShop = !this.reviewShowShop
    },
    claimCheck (claimId, id) {
      if (this.kredits_create >= this.kredits) {
        let obj = {
          title: 'Fejl',
          message: 'Du skal købe flere kilpkort',
          type: 'error',
          customCloseBtnText: 'Luk'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.show = true
      this.isLoadingSubmit = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'claimcheck', salesPerson: this.salesPerson, claimId: claimId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            this.isLoadingSubmit = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
              setTimeout(function () { document.getElementById(id).click() }, 2500)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    creditSubmit () {
      if (this.kredits_create >= this.kredits) {
        let obj = {
          title: 'Fejl',
          message: 'Du skal købe flere kilpkort',
          type: 'error',
          customCloseBtnText: 'Luk'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.show = true
      this.isLoadingSubmit = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'creditcheck', salesPerson: this.salesPerson, creditCheck: this.creditCheck}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            this.isLoadingSubmit = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
              this.creditCheck.firstName = ''
              this.creditCheck.lastName = ''
              this.creditCheck.email = ''
              this.creditCheck.phone = ''
              this.creditCheck.streetName = ''
              this.creditCheck.houseNumber = ''
              this.creditCheck.houseFloor = ''
              this.creditCheck.city = ''
              this.creditCheck.zip = ''
              this.creditCheck.cprNumber = ''
              this.creditCheck.consent = ''
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    hideModal () {
      this.$refs.conditions.hide()
    }
  }
}
</script>
<style>
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
}
.creditcheck-container > .card-body {
  padding: 0!important;
}
.modal-header {
  border-bottom: 0;
}
.modal-footer {
  border-top: 0;
}
</style>


// WEBPACK FOOTER //
// CreditCheck.vue?32e51dde